import Album from './Album';

function App() {
  return (
    <div>
      <Album />
    </div>
  );
}

export default App;
